import get from "lodash/get";
declare var UIkit;

const humanFileSize = (bytes, si = true, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {})
    : {};
};

const loadRemoteResource = async (type, url) => {
  return new Promise(function (resolve, reject) {
    // IF resource already exists, early return
    if (document.getElementById(url)) resolve("");

    if (type == "text/css") {
      const link = document.createElement("link");
      link.id = url;
      link.rel = "stylesheet";
      link.href = url;
      document.head.appendChild(link);
      link.onload = function () {
        resolve("");
      };
    }

    if (type == "text/javascript") {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.id = url;
      document.head.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
    }
  });
};

const getSuppliedByDates = (type) => {
  const now = new Date();
  switch (type) {
    case "min":
      // 2 years ago
      now.setDate(now.getDate() - 365 * 2);
      return now.toISOString().split("T")[0];
    case "max":
      return now.toISOString().split("T")[0];
  }
};

const hashCode = (string: string) => {
  var hash = 0,
    i,
    chr;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

const genAnchor = (
  searchParams: string,
  page: number = 1,
  filter?: number,
  groupMembers?: Array<number>,
) => {
  const params = new URLSearchParams(searchParams);
  const existingFilters = params.get("filters")?.split(",").map(Number) || [];
  if (filter == -1) params.delete("filters");

  if (filter && filter > -1) {
    // limit to 1 filter per group
    const groupLimit = existingFilters.filter((ef) =>
      groupMembers.includes(ef) ? false : true,
    );
    const newFilters = [...groupLimit, filter];
    params.set("filters", newFilters.join(","));
  }
  const path = window.location.pathname.split("/")[1];
 return (
    `/${path}/${page}` +
    (Array.from(params).length > 0 ? `?${params.toString()}` : "")
  );
};

const genAnchorField = (
  searchParams: string,
  page: number = 1,
  field: string,
  filter?: number,
  multi?: boolean,
) => {
  const params = new URLSearchParams(searchParams);
  const existingFilters = params.get(field)?.split(",").map(Number) || [];
  if (filter == -1) params.delete(field);

  if (filter && filter > -1) {
    if (multi) {
      const newFilters = [...existingFilters, filter];
      params.set(field, newFilters.join(","));
    } else {
      params.set(field, filter.toString());
    }
  }
  const path = window.location.pathname.split("/")[1];
  return (
    `/${path}/${page}` +
    (Array.from(params).length > 0 ? `?${params.toString()}` : "")
  );
};

const formatCost = (currency: string, number: number) => {
  return `${currency}${Number((number * 1.0).toFixed(2)).toLocaleString(
    "en-US",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  )}`;
};

const formatLineSummary = (
  currency: string,
  cost: number,
  quantity: number,
  title: string,
) => {
  const formattedCost = `${currency}${Number(
    (cost * 1.0).toFixed(2),
  ).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  return `${title} ${quantity}X${formattedCost}`;
};

const formatModelList = (models) => {
  const Models = (get(models, "data") || []).map(
    ({ attributes: { Title } }) => Title,
  );

  return Models.join(", ") || "-";
};

const shopToLink = (shop) => {
  const root = location.protocol + "//" + location.host + "/checkout";
  const products = shop.Basket.reduce(
    (a, c) => a + c.PartNumber + "@" + c.Quantity + "||",
    "",
  );
  const discount = shop.DiscountCode;
  return `${root}?basket=${products}&code=${discount}`;
};

const copyBasketToClipboard = (link) => {
  navigator.clipboard.writeText(link);
  const options = {
    message: `<div class='uk-background-primary-striped uk-light uk-padding-small'><div class="uk-heading-small uk-margin-remove">Link copied to clipboard</div></div>`,
    pos: "bottom-right",
    timeout: 1000,
  };
  UIkit.notification(options);
};

const generateMailToBasket = (link) => {
  const mailto = "";
  const cc = "spares@howardsongroup.com";
  const subject = "Howardson Group Shop - Basket Link";
  const body = `Your basket link: ${link}`;
  return `mailto:${mailto}?cc=${cc}&subject=${subject}&body=${body}`;
};

export {
  genAnchor,
  genAnchorField,
  humanFileSize,
  getQueryStringParams,
  loadRemoteResource,
  getSuppliedByDates,
  hashCode,
  formatCost,
  formatLineSummary,
  formatModelList,
  copyBasketToClipboard,
  generateMailToBasket,
  shopToLink,
};
